import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useSelector } from "react-redux";

//Assets
import flower_icon from "../../assets/flower_icon.svg";
import copy_icon from "../../assets/icons/copy_small.svg";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";

//Btns
import back_btn from "../../assets/buttons/back_btn.svg";
import next_btn from "../../assets/buttons/next_btn.svg";
import { shortenAddress } from "../../utils/shortenAddress";
import env from "../../constants/env";
import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";

const ConfigSection = ({
  nftData,
  proxy_token_exists,
}: {
  nftData: any;
  proxy_token_exists: boolean;
}) => {

  let selectedAssetInfo = useSelector(
    (state: any) => state.walletState.selectedAssetInfo
  );

  if (!selectedAssetInfo) {
    return <p>loading...</p>;
  }
  return (
    <section
      css={css`
          display: flex;
          margin-top: 40px;
          border: 1px solid #ccc4b3;
          border-radius: 12px;
          padding: 32px;
          flex-direction: column;

          @media (max-width: ${MOBILE}px) {
            width: 100%;
            padding: 24px 16px;
            height: max-content;
          }
        `}
    >
      <div
        css={css`
            display: 100%;
            display: flex;
          `}
      >
        <span
          css={css`
              display: flex;
              flex-direction: column;
              width: 75%;
              margin-top: 70px;

              @media (max-width: ${MOBILE}px) {
                margin-top: 0;
              }
            `}
        >
          <h1
            css={css`
                font-weight: 700;
                font-size: 24px;
                margin: 0;

                @media (max-width: ${MOBILE}px) {
                  font-size: 16px;
                }
              `}
          >
            Proxy Token Mint Signature Info
          </h1>
        </span>
        <img
          css={css`
              width: 128px;
              height: 128px;

              @media (max-width: ${MOBILE}px) {
                width: 64px;
                height: 64px;
              }
            `}
          src={flower_icon}
          alt=""
        />
      </div>
      <div
        css={css`
            display: flex;
            flex-direction: column;
            margin-top: 36px;
            gap: 24px;
          `}
      >
        {["Contract Address", "Token ID", "Token Standard", "Blockchain"].map(
          (info) => {
            let labelMap: any = {
              "Contract Address": "token_address",
              "Token ID": "token_id",
              "Token Standard": "",
              Blockchain: "",
            };
            let value = selectedAssetInfo[labelMap[info]] || "N/A";
            if (info === "Blockchain") {
              let chain = window.location.pathname.split("/")[2];
              if (chain == "ETH") {
                value = "Ethereum";
              }
              if (chain == "POLYGON") {
                value = "Polygon";
              }
            }
            return (
              <InfoTag
                label={info}
                value={value}
                title={info === "Contract Address" ? shortenAddress(value) : ''}
                key={"info" + info}
              />
            );
          }
        )}
      </div>

      {proxy_token_exists && (
        <div
          css={css`
              font-size: 16px;
              margin-top: 24px;
              color: ${colors.SYSTEM_WARNING};
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-weight: 500;
            `}
        >
          <div
            css={css`
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50px;
                height: 50px;
                margin-right: 16px;
              `}
          >
            <svg
              width="128"
              height="128"
              viewBox="0 0 128 128"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M89.1771 7.45767C77.9771 1.35767 64.0771 0.0576658 52.3771 5.15767C40.2771 10.3577 32.0771 21.7577 27.4771 34.1577C22.7771 46.8577 21.0771 61.0577 26.9771 73.2577C32.8771 85.4577 45.2771 92.2577 57.7771 97.3577C71.1771 102.658 85.8771 108.058 99.0771 102.158C112.477 96.1577 122.077 82.3577 123.677 67.7577C125.077 54.9577 113.077 45.9577 106.677 34.7577C101.177 24.9577 99.0771 12.8577 89.1771 7.45767Z"
                fill="#F98585"
              />
              <path
                d="M74.2422 43.6018C75.0146 43.9012 75.398 44.7701 75.0986 45.5426C69.1647 60.8504 67.7919 69.3227 66.8779 74.9635C66.7383 75.825 66.6094 76.6204 66.4767 77.3641C66.331 78.1796 65.5518 78.7227 64.7363 78.577C63.9208 78.4314 63.3777 77.6522 63.5234 76.8367C63.6542 76.1039 63.782 75.3151 63.9211 74.4572C64.8419 68.7746 66.2545 60.0575 72.3014 44.4583C72.6008 43.6858 73.4697 43.3024 74.2422 43.6018Z"
                fill="#191414"
              />
              <path
                d="M65.4759 86.2327C65.6237 87.6056 64.7641 88.8239 63.556 88.9539C62.3479 89.0839 61.2487 88.0764 61.101 86.7035C60.9533 85.3307 61.8129 84.1124 63.021 83.9824C64.2291 83.8524 65.3282 84.8599 65.4759 86.2327Z"
                fill="#191414"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M95.4748 117.227L95.4832 117.229L95.4916 117.23C102.495 118.589 109.53 117.19 113.668 112.699C117.906 108.1 118.628 100.815 114.128 91.505L114.126 91.5003C113.302 89.8116 112.466 88.1266 111.621 86.423L111.619 86.4184L111.617 86.4152C104.357 71.7773 96.4128 55.7606 89.6441 24.1437L89.6432 24.1397C88.3732 18.2864 84.2372 14.2877 79.0402 13.2256C73.8511 12.1652 67.8687 14.0748 62.8793 19.4358L62.8781 19.4371C54.3466 28.6249 42.566 44.7833 32.959 58.5754C28.1457 65.4855 23.8619 71.8251 20.7815 76.4371C19.2412 78.7433 18.0015 80.618 17.1465 81.9165C16.7191 82.5658 16.3878 83.071 16.1632 83.4142C16.0509 83.5858 15.9653 83.7169 15.9077 83.8052L15.8649 83.8709C12.194 88.3799 10.6171 94.4837 11.9903 99.6435C12.6869 102.261 14.1477 104.637 16.474 106.377C18.7968 108.116 21.8876 109.15 25.7357 109.257C43.6584 109.755 61.097 111.747 74.0632 113.617C80.5439 114.552 85.902 115.456 89.6378 116.125C91.5056 116.46 92.9676 116.736 93.9613 116.928C94.4582 117.024 94.8379 117.099 95.0928 117.15L95.293 117.19L95.3804 117.208L95.4522 117.222L95.4738 117.227L95.4748 117.227ZM78.4395 16.1649C74.4539 15.3504 69.4868 16.7404 65.0765 21.4784C56.7081 30.4906 45.0387 46.4822 35.4207 60.2901C30.6214 67.18 26.349 73.5029 23.2762 78.1034C21.74 80.4034 20.504 82.2725 19.6522 83.5662C19.2264 84.213 18.8966 84.7159 18.6735 85.0569C18.562 85.2274 18.477 85.3574 18.4201 85.4446L18.3348 85.5755L17.0773 84.7577C18.3346 85.5759 18.3346 85.5758 18.3348 85.5755L18.2892 85.6456L18.2364 85.7099C15.0453 89.5946 13.7942 94.7568 14.8894 98.872C15.4303 100.905 16.5382 102.679 18.2713 103.975C20.0078 105.275 22.467 106.165 25.819 106.258C43.8963 106.76 61.4577 108.768 74.4915 110.648C81.0107 111.588 86.4027 112.497 90.1669 113.172C92.0491 113.509 93.5246 113.788 94.5308 113.982C95.034 114.08 95.4198 114.156 95.6806 114.208L95.8442 114.241L95.977 114.268L96.0529 114.283L96.063 114.285L96.071 114.287C102.464 115.525 108.276 114.124 111.462 110.666C114.549 107.316 115.627 101.502 111.428 92.8129C110.608 91.1309 109.774 89.4494 108.929 87.7465L108.927 87.7429C101.638 73.048 93.5586 56.7589 86.7108 24.773C85.6802 20.0279 82.4167 16.9776 78.4395 16.1649Z"
                fill="#191414"
              />
            </svg>
          </div>
          <div>
            Proxy Token already exists for this NFT, if you mint a new one,
            the old one will be burned.
          </div>
        </div>
      )}
    </section>

  );
};

const InfoTag = ({ title, label, value }: { label: string; value: string, title?: string; }) => {
  const [isCopying, setIsCopying] = useState(false)
  return (
    <span
      css={css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <p
        css={css`
          font-weight: 500;
          font-size: 16px;
          color: #757272;
          margin: 0;
          margin-right: auto;
          width: max-content;

          @media (max-width: ${MOBILE}px) {
            font-size: 14px;
          }
        `}
      >
        {label}
      </p>
      <span
        css={css`
          display: flex;
          flex-grow: 1;
          border: 1px dashed #a29b8b84;
          margin: 0 8px;
          margin-top: auto;
          margin-bottom: 5px;
        `}
      ></span>
      <h1
        css={css`
          font-weight: 500;
          font-size: 16px;
          color: #191414;
          margin: 0;
          margin-left: auto;

          @media (max-width: ${MOBILE}px) {
            font-size: 14px;
          }
        `}
      >
        {title || value}
      </h1>
      {
        isCopying ?
          <CheckIcon
            css={css`
            margin-left: 5px;
            circle{
              fill: #96da96;
            }
            path{
              fill: #036403;
            }
          `}
          />
          : <img
            onClick={() => {
              navigator.clipboard.writeText(value);
              setIsCopying(true)
              setTimeout(() => {
                setIsCopying(false)
              }, 600);
            }}
            css={css`
              margin-left: 5px;
              cursor: pointer;
              &:hover {
                margin-left: 10px;
                transform: scale(1.2);
                transition: all 0.2s ease-in-out;
              }
            `}
            src={copy_icon}
            alt=""
          />
      }
    </span>
  );
};

export default ConfigSection;
